// extracted by mini-css-extract-plugin
export var memberName = "member-tile-module--member-name--iDJgi";
export var memberTile = "member-tile-module--member-tile--ghXNx";